// src/dashboard/reducers/companyConfig.js
import {
  FETCH_COMPANY_CONFIG_REQUEST,
  FETCH_COMPANY_CONFIG_SUCCESS,
  FETCH_COMPANY_CONFIG_FAILURE,
  UPDATE_COMPANY_CONFIG_REQUEST,
  UPDATE_COMPANY_CONFIG_SUCCESS,
  UPDATE_COMPANY_CONFIG_FAILURE,
} from "../actions/dashboards";

const initialState = {
  data: null,
  status: "idle",
  error: null,
  fetchedAt: 0,
  updateStatus: "idle",
  updateError: null,
};

export default function companyConfigReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_COMPANY_CONFIG_REQUEST:
      return { ...state, status: "loading", error: null };
    case FETCH_COMPANY_CONFIG_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        status: "success",
        error: null,
        fetchedAt: Date.now(),
      };
    case FETCH_COMPANY_CONFIG_FAILURE:
      return { ...state, status: "error", error: action.payload.error };

    case UPDATE_COMPANY_CONFIG_REQUEST:
      return { ...state, updateStatus: "loading", updateError: null };
    case UPDATE_COMPANY_CONFIG_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        updateStatus: "success",
        updateError: null,
        fetchedAt: Date.now(),
      };
    case UPDATE_COMPANY_CONFIG_FAILURE:
      return { ...state, updateStatus: "error", updateError: action.payload.error };

    default:
      return state;
  }
}
